import React, { useState } from 'react';
import { TrendingUp, Download, CheckCircle2 } from 'lucide-react';

export const AnalyticsBIModule: React.FC = () => {
  const [dateRange, setDateRange] = useState('ACADEMIC_YEAR_2026');
  const [exportedMsg, setExportedMsg] = useState('');

  const handleExportReport = () => {
    setExportedMsg('Executive BI Analytics Report exported as PDF & Excel!');
    setTimeout(() => setExportedMsg(''), 4000);
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-purple-100 text-purple-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            Executive Business Intelligence & Analytics
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Executive Analytics BI Dashboard</h2>
          <p className="text-xs text-slate-500">Institutional IEP compliance rates, therapist productivity gauges, and outcome BI</p>
        </div>

        <button 
          onClick={handleExportReport}
          className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white font-bold text-xs rounded-xl shadow transition flex items-center gap-1.5"
        >
          <Download className="w-4 h-4" />
          <span>Export BI Audit Report</span>
        </button>
      </div>

      {exportedMsg && (
        <div className="p-3 bg-emerald-50 border border-emerald-200 text-emerald-900 rounded-xl text-xs font-bold flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-emerald-600" />
          {exportedMsg}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-2">
          <label className="block text-xs font-bold text-slate-700">Analytics Timeframe</label>
          <select 
            value={dateRange}
            onChange={(e) => setDateRange(e.target.value)}
            className="w-full px-3 py-2 border rounded-xl text-xs font-bold bg-white focus:ring-2 focus:ring-purple-500"
          >
            <option value="CURRENT_QUARTER">Current Quarter (Q3 2026)</option>
            <option value="ACADEMIC_YEAR_2026">Academic Year 2025-2026</option>
            <option value="ALL_TIME">All-Time Institutional Data</option>
          </select>
        </div>

        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-1">
          <div className="text-xs font-bold text-slate-500">IEP Mastery Compliance</div>
          <div className="text-2xl font-black text-purple-600 font-mono">94.8% Compliant</div>
        </div>

        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-1">
          <div className="text-xs font-bold text-slate-500">Therapist Billable Hours</div>
          <div className="text-2xl font-black text-emerald-600 font-mono">1,420 Hours</div>
        </div>
      </div>
    </div>
  );
};
